"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRegItemsPublicData = void 0;
const EventRegItemPublic_1 = require("./EventRegItemPublic");
class EventRegItemsPublicData {
    constructor(fieldNames, regItems) {
        this.fieldNames = fieldNames;
        this.regItems = regItems;
    }
    static fromDto(dto) {
        return new EventRegItemsPublicData(dto.fieldNames, dto.regItems.map(regItem => EventRegItemPublic_1.EventRegItemPublic.fromDto(regItem)));
    }
    static empty() {
        return new EventRegItemsPublicData({}, []);
    }
    get isEmpty() {
        return this.regItems.length === 0;
    }
}
exports.EventRegItemsPublicData = EventRegItemsPublicData;
